/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { disclosuresByProfileByFrameworkByLatestYearList } from '../fn/esg-framework/disclosures-by-profile-by-framework-by-latest-year-list';
import { DisclosuresByProfileByFrameworkByLatestYearList$Params } from '../fn/esg-framework/disclosures-by-profile-by-framework-by-latest-year-list';
import { disclosuresByProfileByFrameworkByYearList } from '../fn/esg-framework/disclosures-by-profile-by-framework-by-year-list';
import { DisclosuresByProfileByFrameworkByYearList$Params } from '../fn/esg-framework/disclosures-by-profile-by-framework-by-year-list';
import { EsgDisclosure } from '../models/esg-disclosure';
import { yearsByProfileByFramework } from '../fn/esg-framework/years-by-profile-by-framework';
import { YearsByProfileByFramework$Params } from '../fn/esg-framework/years-by-profile-by-framework';

@Injectable({ providedIn: 'root' })
export class EsgFrameworkService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `disclosuresByProfileByFrameworkByLatestYearList()` */
  static readonly DisclosuresByProfileByFrameworkByLatestYearListPath = '/esg/profile/{profileId}/esg/framework/{framework}/year';

  /**
   * List existing ESGs for profile by framework (e.g. GRI, ESRS, ... ).
   * If ESGs for multiple years of framework exists, only ESGs for latest year (for example current year) are returned.
   *
   * If year has set in Year Config as private for profile (framework independent/not considering framework),
   * then only SH Admin or Profile Admin can access ESGs for that year.
   * .
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `disclosuresByProfileByFrameworkByLatestYearList()` instead.
   *
   * This method doesn't expect any request body.
   */
  disclosuresByProfileByFrameworkByLatestYearList$Response(params: DisclosuresByProfileByFrameworkByLatestYearList$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<EsgDisclosure>>> {
    return disclosuresByProfileByFrameworkByLatestYearList(this.http, this.rootUrl, params, context);
  }

  /**
   * List existing ESGs for profile by framework (e.g. GRI, ESRS, ... ).
   * If ESGs for multiple years of framework exists, only ESGs for latest year (for example current year) are returned.
   *
   * If year has set in Year Config as private for profile (framework independent/not considering framework),
   * then only SH Admin or Profile Admin can access ESGs for that year.
   * .
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `disclosuresByProfileByFrameworkByLatestYearList$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  disclosuresByProfileByFrameworkByLatestYearList(params: DisclosuresByProfileByFrameworkByLatestYearList$Params, context?: HttpContext): Observable<Array<EsgDisclosure>> {
    return this.disclosuresByProfileByFrameworkByLatestYearList$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<EsgDisclosure>>): Array<EsgDisclosure> => r.body)
    );
  }

  /** Path part for operation `disclosuresByProfileByFrameworkByYearList()` */
  static readonly DisclosuresByProfileByFrameworkByYearListPath = '/esg/profile/{profileId}/esg/framework/{framework}/year/{year}';

  /**
   * List existing ESGs for profile by framework and year.
   *
   * If year has set in Year Config as private for profile (framework independent/not considering framework), 
   * then only SH Admin or Profile Admin can access ESGs for that year.
   * .
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `disclosuresByProfileByFrameworkByYearList()` instead.
   *
   * This method doesn't expect any request body.
   */
  disclosuresByProfileByFrameworkByYearList$Response(params: DisclosuresByProfileByFrameworkByYearList$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<EsgDisclosure>>> {
    return disclosuresByProfileByFrameworkByYearList(this.http, this.rootUrl, params, context);
  }

  /**
   * List existing ESGs for profile by framework and year.
   *
   * If year has set in Year Config as private for profile (framework independent/not considering framework), 
   * then only SH Admin or Profile Admin can access ESGs for that year.
   * .
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `disclosuresByProfileByFrameworkByYearList$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  disclosuresByProfileByFrameworkByYearList(params: DisclosuresByProfileByFrameworkByYearList$Params, context?: HttpContext): Observable<Array<EsgDisclosure>> {
    return this.disclosuresByProfileByFrameworkByYearList$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<EsgDisclosure>>): Array<EsgDisclosure> => r.body)
    );
  }

  /** Path part for operation `yearsByProfileByFramework()` */
  static readonly YearsByProfileByFrameworkPath = '/esg/profile/{profileId}/esg/framework/{framework}/years';

  /**
   * List years for which profile has some ESG disclosures.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `yearsByProfileByFramework()` instead.
   *
   * This method doesn't expect any request body.
   */
  yearsByProfileByFramework$Response(params: YearsByProfileByFramework$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<number>>> {
    return yearsByProfileByFramework(this.http, this.rootUrl, params, context);
  }

  /**
   * List years for which profile has some ESG disclosures.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `yearsByProfileByFramework$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  yearsByProfileByFramework(params: YearsByProfileByFramework$Params, context?: HttpContext): Observable<Array<number>> {
    return this.yearsByProfileByFramework$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<number>>): Array<number> => r.body)
    );
  }

}
